import React from 'react';
import 'lord-icon-element'; // Import Lordicon support

const AnimatedIcon: React.FC = () => {
  return (
    <lord-icon
      src="https://cdn.lordicon.com/tdrtiskw.json"
      trigger="loop"
      colors="primary:#f7b84b,secondary:#405189"
      style={{ width: '130px', height: '130px' }}
    />
  );
};

export default AnimatedIcon;
